
import { contains, filter, append, ofArray, singleton, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Requests_ProjectFormDto_$reflection, Project_$reflection, User_$reflection, Requests_ProjectFormDto } from "../../Shared/User.js";
import { FormState__setValidationResponse_5219762A, BusinessUnitId__get_unwrap, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { PropertyConfigurationEnabledResponse, PropertyConfiguration_$reflection, PropertyConfigurationEnabledResponse_$reflection } from "../../Shared/PropertyConfiguration.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { string_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { getAccountSettings } from "../../Requests/Customer.js";
import { getResponsibleBusinessUnits } from "../../Requests/BusinessUnit.js";
import { isNullOrEmpty, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrapUserId } from "../../Shared/Helper.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { equals, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { RouterModule_nav, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../Common.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

export const emptyProject = new Requests_ProjectFormDto("", "", "", empty(), empty(), undefined, empty(), undefined);

export const initialState = new State(undefined, new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), false, FormState_get_empty(), new RequestedValue$1(0, []), new RequestedValue$1(0, []));

export function initNew() {
    return [new State(initialState.ProjectId, new RequestedValue$1(1, [emptyProject]), initialState.IsCustomPropertiesEnabled, initialState.PropertyConfigurations, initialState.Users, initialState.VisibleUserModalIsOpen, initialState.FormState, initialState.BusinessUnits, initialState.AccountSettings), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PropertyConfigurationEnabledResponse_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/property-configurations/enabled", (Item) => (new Msg(12, [Item])), (Item_1) => (new Msg(17, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(PropertyConfiguration_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_3 = _arg_1;
            return (result_3.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_3.fields[0]);
            })())) : (Promise.resolve(result_3.fields[0]));
        });
    })), "/api/property-configurations", (Item_2) => (new Msg(13, [Item_2])), (Item_3) => (new Msg(17, [Item_3]))), Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_8;
        return ((url_8 = addPrefix(url_6), (refreshOn_2) => fetchWithDecoder(url_8, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_4) => {
            const pr_2 = response_4.arrayBuffer();
            return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(User_$reflection())));
        }, refreshOn_2)))(true).then((_arg_2) => {
            const result_5 = _arg_2;
            return (result_5.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_5.fields[0]);
            })())) : (Promise.resolve(result_5.fields[0]));
        });
    })), "/api/receivers/users/active", (Item_4) => (new Msg(14, [Item_4])), (Item_5) => (new Msg(17, [Item_5]))), getAccountSettings((Item_6) => (new Msg(15, [Item_6])), (Item_7) => (new Msg(17, [Item_7]))), getResponsibleBusinessUnits((Item_8) => (new Msg(16, [Item_8])), (Item_9) => (new Msg(17, [Item_9])))]))];
}

export function initEdit(projectId) {
    return [initialState, Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), Project_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/receivers/projects/", ...unwrapUserId(projectId)), (Item) => (new Msg(10, [Item])), (Item_1) => (new Msg(17, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), PropertyConfigurationEnabledResponse_$reflection()));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_3 = _arg_1;
            return (result_3.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_3.fields[0]);
            })())) : (Promise.resolve(result_3.fields[0]));
        });
    })), "/api/property-configurations/enabled", (Item_2) => (new Msg(12, [Item_2])), (Item_3) => (new Msg(17, [Item_3]))), Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_8;
        return ((url_8 = addPrefix(url_6), (refreshOn_2) => fetchWithDecoder(url_8, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_4) => {
            const pr_2 = response_4.arrayBuffer();
            return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(PropertyConfiguration_$reflection())));
        }, refreshOn_2)))(true).then((_arg_2) => {
            const result_5 = _arg_2;
            return (result_5.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_5.fields[0]);
            })())) : (Promise.resolve(result_5.fields[0]));
        });
    })), "/api/property-configurations", (Item_4) => (new Msg(13, [Item_4])), (Item_5) => (new Msg(17, [Item_5]))), Cmd_OfPromise_either((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_11;
        return ((url_11 = addPrefix(url_9), (refreshOn_3) => fetchWithDecoder(url_11, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_6) => {
            const pr_3 = response_6.arrayBuffer();
            return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), list_type(User_$reflection())));
        }, refreshOn_3)))(true).then((_arg_3) => {
            const result_7 = _arg_3;
            return (result_7.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_7.fields[0]);
            })())) : (Promise.resolve(result_7.fields[0]));
        });
    })), "/api/receivers/users/active", (Item_6) => (new Msg(14, [Item_6])), (Item_7) => (new Msg(17, [Item_7]))), getAccountSettings((Item_8) => (new Msg(15, [Item_8])), (Item_9) => (new Msg(17, [Item_9]))), getResponsibleBusinessUnits((Item_10) => (new Msg(16, [Item_10])), (Item_11) => (new Msg(17, [Item_11])))]))];
}

export function update(msg, state) {
    let body_3, fullPath;
    switch (msg.tag) {
        case 1: {
            const matchValue_1 = state.Form;
            if (matchValue_1.tag === 1) {
                const project_1 = matchValue_1.fields[0];
                return [new State(state.ProjectId, new RequestedValue$1(1, [new Requests_ProjectFormDto(project_1.Name, msg.fields[0], project_1.ImageUrl, project_1.QRCodeIds, project_1.VisibleForUserIds, project_1.Email, project_1.CustomProperties, project_1.BusinessUnitId)]), state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 2: {
            const email = msg.fields[0];
            const matchValue_2 = state.Form;
            if (matchValue_2.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const project_2 = matchValue_2.fields[0];
                return [new State(state.ProjectId, new RequestedValue$1(1, [new Requests_ProjectFormDto(project_2.Name, project_2.Description, project_2.ImageUrl, project_2.QRCodeIds, project_2.VisibleForUserIds, isNullOrEmpty(email.trim()) ? undefined : email, project_2.CustomProperties, project_2.BusinessUnitId)]), state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
        }
        case 3: {
            const matchValue_3 = state.Form;
            if (matchValue_3.tag === 1) {
                const project_3 = matchValue_3.fields[0];
                return [new State(state.ProjectId, new RequestedValue$1(1, [new Requests_ProjectFormDto(project_3.Name, project_3.Description, project_3.ImageUrl, project_3.QRCodeIds, project_3.VisibleForUserIds, project_3.Email, msg.fields[0], project_3.BusinessUnitId)]), state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 5: {
            const matchValue_4 = state.Form;
            if (matchValue_4.tag === 1) {
                return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, FormState__startLoading(state.FormState), state.BusinessUnits, state.AccountSettings), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), ["/api/receivers/projects", toString(0, Auto_generateBoxedEncoder_437914C6(Requests_ProjectFormDto_$reflection(), undefined, undefined, undefined)(matchValue_4.fields[0]))], (Item) => (new Msg(11, [Item])), (Item_1) => (new Msg(17, [Item_1])))];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 6: {
            const matchValue_5 = state.ProjectId;
            const matchValue_6 = state.Form;
            let matchResult, project_6, projectId;
            if (matchValue_5 != null) {
                if (matchValue_6.tag === 1) {
                    matchResult = 1;
                    project_6 = matchValue_6.fields[0];
                    projectId = matchValue_5;
                }
                else {
                    matchResult = 0;
                }
            }
            else {
                matchResult = 0;
            }
            switch (matchResult) {
                case 0:
                    return [state, Cmd_none()];
                default:
                    return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, FormState__startLoading(state.FormState), state.BusinessUnits, state.AccountSettings), (body_3 = toString(0, Auto_generateBoxedEncoder_437914C6(Requests_ProjectFormDto_$reflection(), undefined, undefined, undefined)(project_6)), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_2) => {
                            const pr_1 = response_2.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                        }, refreshOn_1)))(true);
                    })), [concat("/api/receivers/projects/", ...projectId), body_3], (Item_2) => (new Msg(11, [Item_2])), (Item_3) => (new Msg(17, [Item_3]))))];
            }
        }
        case 7:
            return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, !state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        case 8: {
            const matchValue_8 = state.Form;
            if (matchValue_8.tag === 1) {
                const project_8 = matchValue_8.fields[0];
                return [new State(state.ProjectId, new RequestedValue$1(1, [new Requests_ProjectFormDto(project_8.Name, project_8.Description, project_8.ImageUrl, project_8.QRCodeIds, append(project_8.VisibleForUserIds, msg.fields[0]), project_8.Email, project_8.CustomProperties, project_8.BusinessUnitId)]), state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, false, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 4: {
            const matchValue_9 = state.Form;
            if (matchValue_9.tag === 1) {
                const vehicle = matchValue_9.fields[0];
                return [new State(state.ProjectId, new RequestedValue$1(1, [new Requests_ProjectFormDto(vehicle.Name, vehicle.Description, vehicle.ImageUrl, vehicle.QRCodeIds, vehicle.VisibleForUserIds, vehicle.Email, vehicle.CustomProperties, map((businessUnit_1) => businessUnit_1.value.Id, msg.fields[0]))]), state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 9: {
            const matchValue_10 = state.Form;
            if (matchValue_10.tag === 1) {
                const project_9 = matchValue_10.fields[0];
                return [new State(state.ProjectId, new RequestedValue$1(1, [new Requests_ProjectFormDto(project_9.Name, project_9.Description, project_9.ImageUrl, project_9.QRCodeIds, filter((userId) => !contains(userId, msg.fields[0], {
                    Equals: (x_2, y) => (x_2 === y),
                    GetHashCode: (x_2) => (stringHash(x_2) | 0),
                }), project_9.VisibleForUserIds), project_9.Email, project_9.CustomProperties, project_9.BusinessUnitId)]), state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, false, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 10: {
            const project_10 = msg.fields[0];
            return [new State(project_10.Id, new RequestedValue$1(1, [new Requests_ProjectFormDto(project_10.Name, project_10.Description, project_10.ImageUrl, project_10.QRCodeIds, project_10.VisibleForUserIds, project_10.Email, project_10.CustomProperties, map(BusinessUnitId__get_unwrap, project_10.BusinessUnitId))]), state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        }
        case 11: {
            const response_4 = msg.fields[0];
            if (response_4.tag === 1) {
                return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, FormState__setValidationResponse_5219762A(state.FormState, response_4.fields[0]), state.BusinessUnits, state.AccountSettings), Cmd_errorToast("validation.toast")];
            }
            else {
                return [state, Cmd_batch(ofArray([(fullPath = RouterModule_encodeParts(ofArray(["receivers", "projects", response_4.fields[0] + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1), Cmd_ofEffect((_arg_1) => {
                    RouterModule_nav(singleton(fullPath), 1, 1);
                })), Cmd_successToast("general.saved_successfully")]))];
            }
        }
        case 12:
            return [new State(state.ProjectId, state.Form, new RequestedValue$1(1, [equals(msg.fields[0], new PropertyConfigurationEnabledResponse(0, []))]), state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        case 13:
            return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, new RequestedValue$1(1, [filter((propertyConfiguration) => {
                const matchValue_11 = propertyConfiguration.Visibility;
                switch (matchValue_11.tag) {
                    case 2:
                    case 0:
                    case 1:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 8:
                    case 9:
                    case 10:
                    case 12:
                    case 11:
                        return false;
                    default:
                        return true;
                }
            }, msg.fields[0])]), state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        case 14:
            return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, state.PropertyConfigurations, new RequestedValue$1(1, [msg.fields[0]]), state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        case 15:
            return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 16:
            return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, new RequestedValue$1(1, [msg.fields[0]]), state.AccountSettings), Cmd_none()];
        case 17:
            return [new State(state.ProjectId, state.Form, state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, FormState_get_empty(), state.BusinessUnits, state.AccountSettings), Cmd_none()];
        default: {
            const matchValue = state.Form;
            if (matchValue.tag === 1) {
                const project = matchValue.fields[0];
                return [new State(state.ProjectId, new RequestedValue$1(1, [new Requests_ProjectFormDto(msg.fields[0], project.Description, project.ImageUrl, project.QRCodeIds, project.VisibleForUserIds, project.Email, project.CustomProperties, project.BusinessUnitId)]), state.IsCustomPropertiesEnabled, state.PropertyConfigurations, state.Users, state.VisibleUserModalIsOpen, state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
    }
}

